function requireLangFile(moduleFiles, elementUiLang) {
  const moduleData = moduleFiles.keys().reduce((pre, item) => {
    if (item.includes('otc')) {
      return pre;
    }

    if (item.includes('.json')) {
      pre = {
        ...pre,
        ...moduleFiles(item),
      };
    } else {
      pre = {
        ...pre,
        ...moduleFiles(item).default,
      };
    }

    return pre;
  }, elementUiLang);

  return moduleData;
}

export default requireLangFile;
